import { createElement } from 'react';
import Carousel from '../carousel/carousel';
import './goods-card-list-common.scss';
const GoodsCardListCommon = ({ dataList = [], maxSales = 1000, onClick = () => { }, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const resolveResultDesc = (desc) => {
        const htmlString = `<div>${desc}</div>`;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        return tempDiv.textContent || tempDiv.innerText;
    };
    return (createElement("div", { className: "card-list-goods-common__container", ..._otherProps }, dataList.map((item) => (createElement("div", { key: item.key, className: "card-list-goods__item", onClick: () => onClick(item) },
        item.imageList && item.imageList.length > 0 && (createElement("div", { className: "card-list-goods__image" },
            createElement(Carousel, { images: item.imageList, interval: 3000 }))),
        createElement("div", { className: "card-list-goods__content" },
            createElement("div", { className: "card-list-goods__title" }, item.title),
            createElement("div", { className: "card-list-goods__desc" }, resolveResultDesc(item.desc)),
            createElement("div", { className: "card-list-goods__bottom" },
                createElement("div", { className: "card-list-goods__unit" }, "\uFFE5"),
                createElement("div", { className: "card-list-goods__price" }, item.activePrice || item.price),
                item.activePrice && createElement("div", { className: "card-list-goods__unit__delete" }, "\uFFE5"),
                item.activePrice && (createElement("div", { className: "card-list-goods__price__delete" }, item.price)),
                createElement("div", { className: "card-list-goods__sales" },
                    "\u5DF2\u552E",
                    item.sales > maxSales ? `${maxSales}+` : item.sales))))))));
};
GoodsCardListCommon.displayName = 'GoodsCardListCommon';
export default GoodsCardListCommon;
